import { useState } from "react";
import { Button } from "react-bootstrap";
import managementService from "../../../services/management.service";
import stockApiService from "../../../services/stockApi.service";
import { useToast } from "../../../hooks";

const LegalTagComment = ({ vehicle_id, handleClose, complete, refresh }) => {
  const [comment, setComment] = useState("");
  const addToast = useToast();
  const [loading, setLoading] = useState(false);

  const changeLegalStatus = () => {
    setLoading(true);
    stockApiService
      .updateTagLegal(vehicle_id, { complete: !complete })
      .then(async (response) => {
        if (response?.data?.success) {
          await managementService.edit({
            comment,
            vehicle_id,
            comment_reason_id: !complete ? 52 : 53,
          });
          addToast({
            variant: "success",
            header: "Toma - Consulta",
            body: "Se actualizó la marca legal correctamente",
          });
          refresh();
        } else {
          addToast({
            variant: "danger",
            header: "Toma - Consulta",
            body: "Ocurrió un error al actualizar la marca legal",
          });
        }
        setLoading(false);
        handleClose();
      });
  };

  return (
    <div className="modalChecklist">
      <div className="container">
        <div className="row">
          <h4>Comentario</h4>
          <textarea
            className="form-control"
            rows="3"
            name="comments"
            onChange={(e) => setComment(e.target.value)}
            style={{ height: 80 }}
          />
        </div>
      </div>
      <br />
      <div className="modal-footer">
        <div>
          <Button
            className="btn-fill pull-right btn btn-primary"
            onClick={() => changeLegalStatus()}
            disabled={loading || comment.trim() === ""}
          >
            Marca legal {complete ? "como incompleto" : "como completo"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LegalTagComment;
